<template>
  <div
    class="w-full shadow-lg border select-none border-primary-100 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
    style="border-radius: 1rem"
  >
    <div style="border-radius: 1rem">
      <div
        class="panel-top flex no-select"
        :class="headerColor"
        style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
      >
        <div class="flex items-center justify-center text-white dark:text-dark-text">
          <span class="text-base material-icons mr-1 font-bold"> {{ icon }} </span>
          <div class="text-base font-bold">{{ title }}</div>
        </div>
        <div class="flex-grow" />
        <slot name="header" />
      </div>
      <div class="w-full" style="border-bottom-right-radius: 1rem; border-bottom-left-radius: 1rem">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BasePanel',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    headerColor: {
      type: String,
      default: 'bg-primary-500 dark:bg-dark-400'
    }
  },
  setup() {
    return {}
  }
})
</script>

<style lang="postcss" scoped>
.panel-top {
  padding: 0.15em 0.75em 0.1em 0.75em;
}
</style>
